var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.94 4.99999C6.93974 5.53043 6.72877 6.03903 6.35351 6.41391C5.97825 6.7888 5.46944 6.99926 4.939 6.99899C4.40857 6.99873 3.89997 6.78776 3.52508 6.4125C3.1502 6.03724 2.93974 5.52843 2.94 4.99799C2.94027 4.46756 3.15124 3.95896 3.5265 3.58407C3.90176 3.20919 4.41057 2.99873 4.941 2.99899C5.47144 2.99926 5.98004 3.21023 6.35492 3.58549C6.72981 3.96075 6.94027 4.46956 6.94 4.99999V4.99999ZM7 8.47999H3V21H7V8.47999ZM13.32 8.47999H9.34V21H13.28V14.43C13.28 10.77 18.05 10.43 18.05 14.43V21H22V13.07C22 6.89999 14.94 7.12999 13.28 10.16L13.32 8.47999V8.47999Z","fill":"current"}));
}

Linkedin.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
